<section class="home-section newsletter" *ngIf="hasNewsletter && !showRedirectBanner">
  <div class="container">
    <div class="newsletter-box">
      <div class="newsletter-box__image" style="background-image: url('https://cdn.pixabay.com/photo/2017/12/15/13/51/polynesia-3021072_960_720.jpg');"></div>
      <div class="newsletter-box__content">
        <h5>Iscriviti alla newsletter!</h5>
        <p>Rimani sempre aggiornato con le migliori offerte</p>
        <button type="submit" class="btn btn--blue" (click)="goToNewsLetter()">Iscriviti</button>
<!--        <form name="newsletter" (ngSubmit)="onSubmit()" #formNl="ngForm">
          <h5>Iscriviti alla newsletter!</h5>
          <p>Rimani sempre aggiornato con le migliori offerte</p>
          &lt;!&ndash;<div class="form-group-custom">
            <label for="newsletterCheckbox" class="form-check-custom">
              <input type="checkbox" name="newsletterCheckbox" id="newsletterCheckbox">Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisi velit. .
              <span class="form-check-custom__check"></span>
            </label>
          </div>&ndash;&gt;
          <div class="form-group-custom d-none d-lg-block">
            <input name="emailAddress" placeholder="Il tuo indirizzo email" class="form-control-custom" required [(ngModel)]="email" email>
            <button type="submit" [disabled]="formNl.invalid" class="btn btn&#45;&#45;blue">Iscriviti</button>
          </div>
          <button type="submit" class="btn btn&#45;&#45;blue d-lg-none">Iscriviti</button>
        </form>-->
      </div>
    </div>
  </div>
</section>
<section class="home-section newsletter" *ngIf="hasNewsletter && showRedirectBanner">
  <div class="container">
    <div class="newsletter-box">
      <div class="newsletter-box__image" style="background-image: url('https://cdn.pixabay.com/photo/2017/12/15/13/51/polynesia-3021072_960_720.jpg');"></div>
      <div class="newsletter-box__content">
        <div name="newsletter" >
          <h5>Iscriviti alla newsletter!</h5>
          <p>Cerca l'agenzia più vicina a te, visita il suo sito e iscriviti alla sua newsletter.</p>
          <a [routerLink]="'/cerca-agenzia'" class="btn btn--blue">Iscriviti</a>
        </div>
      </div>
    </div>
  </div>
</section>
